























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SiteRole, siteAdminRoleApis, InvalidParam, roleType } from '../../api';

@Component
export default class RoleEditDialog extends Vue {
  readonly rules = {
    name: { required: true, message: '请输入角色标识' },
    title: { required: true, message: '请输入角色名称' }
  };

  @Prop() siteId!: number;
  @Prop() tabValue!: string;
  role: SiteRole | null = null;
  dialogVisible = false;
  resolve: ((perm: SiteRole) => void) | null = null;
  errors = {};

  show(role: SiteRole | null) {
    if (role) {
      this.role = JSON.parse(JSON.stringify(role));
    } else {
      this.role = { site_id: this.siteId } as SiteRole;
    }
    this.dialogVisible = true;
    return new Promise<SiteRole>(resolve => (this.resolve = resolve));
  }

  async save() {
    try {
      if (this.role) {
        const role = await siteAdminRoleApis.saveRole(this.role, roleType[this.tabValue]);
        if (this.resolve) {
          this.resolve(role);
        }
      }
      this.dialogVisible = false;
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error(e.message);
      }
    }
  }

  onClosed() {
    this.role = null;
    this.resolve = null;
  }
}
